import moment, { Moment } from "moment";

export const filterByDate = <T>(
    items: T[],
    dateGetter: (item: T) => Date | string | null | undefined,
    predicate: (date: Moment) => boolean,
    format: string = "DD.MM.YYYY"
): string[] =>
    items.reduce<string[]>((acc, item) => {
        const date = moment(dateGetter(item));

        return date.isValid() && predicate(date) ? [...acc, date.format(format)] : acc;
    }, []);
